import { render } from "./Main-page.vue?vue&type=template&id=beb22848"
import script from "./Main-page.vue?vue&type=script&lang=js"
export * from "./Main-page.vue?vue&type=script&lang=js"

import "./Main-page.vue?vue&type=style&index=0&id=beb22848&lang=css"

import exportComponent from "/Volumes/DEXP W500C/homePc/актуально/new-dff/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__